import { render, staticRenderFns } from "./Comp30t2.vue?vue&type=template&id=6a8a93a5&scoped=true&"
import script from "./Comp30t2.vue?vue&type=script&lang=js&"
export * from "./Comp30t2.vue?vue&type=script&lang=js&"
import style0 from "./Comp30t2.vue?vue&type=style&index=0&id=6a8a93a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8a93a5",
  null
  
)

export default component.exports